function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "20px", lineHeight: "1.8" }}>
      <h1>Privacy Policy – Vinirji Food App</h1>

      <p><strong>Last Updated:</strong> June 2026</p>

      <p>
        Welcome to Vinirji Food App. Your privacy is important to us. This Privacy
        Policy explains how we collect, use, store, and protect your information
        when you use our website and mobile application.
      </p>

      <h2>1. Information We Collect</h2>

      <h3>Personal Information</h3>
      <p>When you register or use Vinirji Food App, we may collect:</p>
      <ul>
        <li>Full name</li>
        <li>Mobile phone number</li>
        <li>Email address</li>
        <li>Delivery address</li>
        <li>Profile information</li>
      </ul>

      <h3>Location Information</h3>
      <p>With your permission, we may collect:</p>
      <ul>
        <li>Current device location</li>
        <li>Delivery location</li>
      </ul>

      <p>
        This information helps us provide accurate delivery services and improve
        user experience.
      </p>

      <h3>Order Information</h3>
      <p>We collect information related to:</p>
      <ul>
        <li>Food orders</li>
        <li>Restaurant selections</li>
        <li>Order history</li>
        <li>Delivery preferences</li>
      </ul>

      <h3>Payment Information</h3>
      <p>
        Payments are processed through trusted third-party payment providers such
        as Razorpay.
      </p>

      <p>
        We do not store your complete debit card, credit card, UPI PIN, or banking
        credentials on our servers.
      </p>

      <h2>2. How We Use Your Information</h2>

      <p>We use your information to:</p>

      <ul>
        <li>Create and manage your account</li>
        <li>Process and deliver food orders</li>
        <li>Verify your identity</li>
        <li>Provide customer support</li>
        <li>Improve our services</li>
        <li>Send order updates and notifications</li>
        <li>Prevent fraud and unauthorized activities</li>
      </ul>

      <h2>3. Google Sign-In</h2>

      <p>
        If you choose to sign in using your Google account, we may receive:
      </p>

      <ul>
        <li>Your name</li>
        <li>Email address</li>
        <li>Profile picture (if provided by Google)</li>
      </ul>

      <p>
        This information is used only for authentication and account management.
      </p>

      <h2>4. Location Permissions</h2>

      <p>Location access is used to:</p>

      <ul>
        <li>Detect your current location</li>
        <li>Improve delivery accuracy</li>
        <li>Display nearby restaurants and services</li>
      </ul>

      <p>
        You may disable location access through your device settings, although
        some features may not function properly.
      </p>

      <h2>5. Sharing of Information</h2>

      <p>We may share information with:</p>

      <ul>
        <li>Restaurant partners</li>
        <li>Delivery partners</li>
        <li>Payment service providers such as Razorpay</li>
        <li>Government authorities when required by law</li>
      </ul>

      <p>We do not sell your personal information to third parties.</p>

      <h2>6. Data Security</h2>

      <p>
        We implement reasonable security measures to protect your personal
        information from unauthorized access, disclosure, alteration, or
        destruction.
      </p>

      <p>
        However, no method of transmission over the internet is completely secure.
      </p>

      <h2>7. Data Retention</h2>

      <p>We retain your information only as long as necessary to:</p>

      <ul>
        <li>Provide services</li>
        <li>Comply with legal obligations</li>
        <li>Resolve disputes</li>
        <li>Enforce our agreements</li>
      </ul>

      <h2>8. Children's Privacy</h2>

      <p>
        Vinirji Food App is not intended for children under the age of 13. We do
        not knowingly collect personal information from children.
      </p>

      <h2>9. Your Rights</h2>

      <p>You may:</p>

      <ul>
        <li>Access your account information</li>
        <li>Update your profile information</li>
        <li>Request account deletion</li>
        <li>Contact us regarding privacy concerns</li>
      </ul>

      <h2>10. Third-Party Services</h2>

      <p>Our services may integrate with third-party providers including:</p>

      <ul>
        <li>Google Sign-In</li>
        <li>Razorpay</li>
        <li>Google Maps and location services</li>
      </ul>

      <p>
        Their use of information is governed by their respective privacy policies.
      </p>

      <h2>11. Changes to This Privacy Policy</h2>

      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with an updated effective date.
      </p>

      <h2>12. Contact Us</h2>

      <p>If you have any questions regarding this Privacy Policy, please contact us:</p>

      <p><strong>Vinirji Food</strong></p>
      <p>Email: support@vinirji.com</p>
      <p>Website: https://vinirji.com</p>
    </div>
  );
}

export default PrivacyPolicy;